import { useContext, useEffect, useRef, useState } from "react";
import { WorkspaceContext } from "src/context/workspace";
import { classNames } from "src/helpers/classNames";
import { addClickPrevention, addSecurityTags, fixIframeUrls, fixInvalidLinks, prepareEmbeddedHtml } from "src/helpers/pageHelper";
import useDevice from "src/hooks/useDevice";

export default function CustomHtmlEmbed({ content }) {
  const { details: workspaceDetails } = useContext(WorkspaceContext);
  const [isIframeLoaded, setIsIframeLoaded] = useState(false);
  const [srcDoc, setSrcDoc] = useState("");
  const iframeRef = useRef(null);
  const device = useDevice();

  useEffect(() => {
    try {
      let rawHtml = content?.custom_html || "";

      if (!rawHtml) {
        setSrcDoc("");
        return;
      }

      const iframeStyles = `<style>
      html, body {
        height: 100% !important;
        margin: 0;
        padding: 0;
        overflow: auto;
      }
      iframe {
        height: 100% !important;
        width: 100% !important;
      }
      </style>`;

      let finalHtml = prepareEmbeddedHtml(rawHtml);

      if (finalHtml.includes("</head>")) {
        finalHtml = finalHtml.replace("</head>", () => `${iframeStyles}</head>`);
      }

      finalHtml = addSecurityTags(finalHtml);
      finalHtml = fixInvalidLinks(finalHtml);
      finalHtml = fixIframeUrls(finalHtml);
      finalHtml = addClickPrevention(finalHtml);

      setSrcDoc(finalHtml);
    } catch (error) {
      console.error("Error processing custom HTML:", error);
    }

    const handleIframeLoad = () => {
      setIsIframeLoaded(true);

      const handleMessage = (event) => {
        if (event.source === iframeRef.current?.contentWindow) {
        }
      };

      window.addEventListener("message", handleMessage);

      return () => {
        window.removeEventListener("message", handleMessage);
      };
    };

    const iframeElement = iframeRef.current;
    if (iframeElement) {
      iframeElement.addEventListener("load", handleIframeLoad);
    }

    return () => {
      if (iframeElement) {
        iframeElement.removeEventListener("load", handleIframeLoad);
      }
    };
  }, [content]);

  return (
    <div className={classNames("relative h-full w-full")}>
      <div
        className={"relative z-0 mx-auto h-full w-full overflow-auto "}
        style={{ maxWidth: device === "desktop" ? workspaceDetails?.max_width || "100%" : "100%" }}>
        <iframe
          ref={iframeRef}
          id="iframe"
          title="Custom Html Embed"
          srcDoc={srcDoc}
          width="100%"
          height="100%"
          sandbox="allow-scripts allow-same-origin allow-forms allow-popups allow-popups-to-escape-sandbox allow-downloads allow-modals"
          style={{
            visibility: isIframeLoaded ? "visible" : "hidden",
            border: "none",
            margin: "0",
          }}
        />
      </div>
    </div>
  );
}
